import PreferencesHitPointConfirmPane from './PreferencesOptionalOriginsConfirmPane';

export default PreferencesHitPointConfirmPane;
export { PreferencesHitPointConfirmPane };
